import { render, staticRenderFns } from "./Partie2.vue?vue&type=template&id=b5e5e9dc&"
import script from "./Partie2.vue?vue&type=script&lang=js&"
export * from "./Partie2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports